import React from 'react'

interface TitleProps {
  children?: React.ReactNode
  className?: string
  variants?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  icon?: React.ReactNode
  text?: string
  iconPosition?: 'start' | 'end'
}
export const Title = ({
  children,
  variants = 'h1',
  className,
  icon,
  text,
  iconPosition = 'start',
}: TitleProps) => {
  const Component = variants
  return (
    <Component
      className={`${icon ? `flex items-center gap-2` : ''} ${className ?? ''} relative mb-3 font-bold`}
    >
      {icon && iconPosition == 'start' && <span>{icon}</span>} {children ?? text}{' '}
      {icon && iconPosition == 'end' && <span>{icon}</span>}
    </Component>
  )
}
